import * as yup from 'yup'
export const schema = yup.object().shape({
    From:yup.string().required("Source currency is required"),
    To:yup.string().required("Destination currency is required"),
    FromCode:yup.string().required("Source currency is required"),
    ToCode:yup.string().required("Destination currency is required"),
    ExchangeRate: yup.number().when(['FromCode','ToCode'],{is:(from,to)=>from!==to, then:yup.number()
            .required('Exchange Rate is required').moreThan(0,'Exchange cannot be 0 or less')
        , otherwise:yup.number().notRequired().nullable(true)}),
    AgencyRate: yup.number().when(['FromCode','ToCode'],{is:(from,to)=>from!==to, then:yup.number()
            .required('Agency Rate is required').moreThan(0,'Agency cannot be 0 or less')
        , otherwise:yup.number().notRequired().nullable(true)})

})